module.exports = __webpack_public_path__ + "media/images/default/join_us/recruit-5d5e9c585b7eea739b071d3a1aa405c1.jpg";